<template lang="pug">
  div
    v-btn.new-contact(icon @click="handleCreateContact")
      v-icon person_add
    create-contact-choice-modal(
      :show="showChoiceModal"
      @close="showChoiceModal = false"
      @create="onCreateContactChoice"
    )
</template>

<script>
import CreateContactChoiceModal from '@/Contacts/components/CreateContactChoiceModal.vue';
import createContactMixin from '@/Contacts/mixins/createContactMixin';

export default {
  components: {
    CreateContactChoiceModal,
  },
  mixins: [createContactMixin],
};
</script>
<style scoped>
  .new-contact {
    background: hsla(0,0%,100%,.16);
    border-radius: 5px;
    height: 42px;
  }

  .v-btn--icon:before {
    border-radius: 0%;
  }
</style>
